import React, { lazy } from 'react';
import { Snowflake, Flame, ChevronDown } from 'lucide-react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  return <section id="how-it-works" className="py-10 bg-gray-50" data-id="element-341">
      <div className="container mx-auto px-4" data-id="element-342">
        <div className="text-center mb-16" data-id="element-343">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gray-800" data-id="element-344">
            La Alternativa Natural a los Medicamentos
          </h2>
          <motion.div className="max-w-lg mx-auto mb-10" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-345">
            <motion.img src="https://uploadthingy.s3.us-west-1.amazonaws.com/i4GitXtz49p37efxiyYGhm/ChatGPT_Image_1_sept_2025%2C_08_56_48_a.m..png" alt="Medicamentos para el dolor y crema analgésica con billetes tachados en el fondo - el costo oculto del alivio temporal" className="rounded-lg shadow-lg w-full max-w-md mx-auto" loading="lazy" width="500" height="500" whileHover={{
            scale: 1.02
          }} transition={{
            duration: 0.3
          }} data-id="element-346" />
            <p className="text-sm text-gray-500 mt-2 italic" data-id="element-347">
              El ciclo interminable: más dolor, más gastos, más dependencia
            </p>
          </motion.div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-348">
            Este dispositivo trabaja en armonía con tu cuerpo. Aplica principios
            de terapia fría y caliente para:
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-10 mb-16" data-id="element-349">
          <div className="text-center" data-id="element-350">
            <div className="bg-blue-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-351">
              <div className="bg-blue-500 rounded-full w-12 h-12 flex items-center justify-center" data-id="element-352">
                <ChevronDown size={24} className="text-white" data-id="element-353" />
              </div>
            </div>
            <h3 className="text-xl font-bold mb-2" data-id="element-354">
              Relajar tejidos profundos
            </h3>
          </div>
          <div className="text-center" data-id="element-355">
            <div className="bg-blue-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-356">
              <div className="bg-blue-500 rounded-full w-12 h-12 flex items-center justify-center" data-id="element-357">
                <ChevronDown size={24} className="text-white" data-id="element-358" />
              </div>
            </div>
            <h3 className="text-xl font-bold mb-2" data-id="element-359">Disminuir inflamación</h3>
          </div>
          <div className="text-center" data-id="element-360">
            <div className="bg-blue-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-361">
              <div className="bg-blue-500 rounded-full w-12 h-12 flex items-center justify-center" data-id="element-362">
                <ChevronDown size={24} className="text-white" data-id="element-363" />
              </div>
            </div>
            <h3 className="text-xl font-bold mb-2" data-id="element-364">
              Calmar la sobrecarga nerviosa
            </h3>
          </div>
        </div>
        <div className="bg-white p-8 rounded-xl shadow-md mb-12" data-id="element-365">
          <h3 className="text-2xl font-bold mb-6 text-center" data-id="element-366">
            Puedes usarlo frío o caliente:
          </h3>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-367">
            <div className="flex items-center p-4 bg-blue-50 rounded-lg" data-id="element-368">
              <Snowflake size={40} className="text-blue-600 mr-4" data-id="element-369" />
              <div data-id="element-370">
                <h4 className="text-xl font-semibold mb-2" data-id="element-371">Frío</h4>
                <p data-id="element-372">10 a 15 minutos</p>
              </div>
            </div>
            <div className="flex items-center p-4 bg-red-50 rounded-lg" data-id="element-373">
              <Flame size={40} className="text-red-500 mr-4" data-id="element-374" />
              <div data-id="element-375">
                <h4 className="text-xl font-semibold mb-2" data-id="element-376">Calor</h4>
                <p data-id="element-377">hasta 10 minutos</p>
              </div>
            </div>
          </div>
          <p className="text-center mt-6 text-gray-600" data-id="element-378">
            Ajusta según tu tolerancia y necesidad.
          </p>
        </div>
      </div>
    </section>;
}